<div
  class="tw-w-fit tw-h-full tw-min-h-[100vh] tw-max-h-[100vh] tw-sticky tw-bg-secondary tw-flex tw-flex-col tw-justify-between tw-rounded-tr-[10px] tw-rounded-br-[10px] tw-overflow-auto tw-py-5 tw-px-5"
>
  <div class="tw-w-full tw-h-fit tw-flex tw-flex-col">
    <div class="tw-w-full tw-h-fit tw-flex tw-flex-col tw-justify-center tw-items-center">
      <div *ngIf="eventEmitterService.showSidebar == true" class="tw-w-full tw-h-fit tw-flex md:tw-hidden tw-justify-end tw-items-center tw-mb-5">
        <div (click)="closeSidebar()" class="tw-min-w-7 tw-min-h-7 tw-max-w-7 tw-max-h-7 tw-flex tw-justify-center tw-items-center tw-bg-white tw-rounded-full tw-cursor-pointer">
          <img class="tw-w-5 tw-h-5 tw-object-contain" src="../../../assets/close-dark-icon.svg" />
        </div>
      </div>

      <img [ngClass]="isExpanded ? 'tw-w-fit' : 'tw-min-w-10 tw-max-w-10'" class="tw-h-14 tw-object-contain" src="../../../assets/logo.svg" />
    </div>
    <div class="tw-w-full tw-h-fit tw-flex tw-flex-col tw-gap-4 tw-items-center tw-py-10">
      <div *ngFor="let tab of tabs" [ngClass]="tab == selectedTab ? 'tab-selected' : 'tab'" (click)="goToRoute(tab.route)">
        <img class="tab-icon" [src]="tab.icon" />
        <img class="tab-icon-selected" [src]="tab.iconSelected" />
        <p [ngClass]="isExpanded ? '' : 'tw-hidden'" class="tab-title">
          {{ tab.title | translate }}
        </p>
      </div>
    </div>
  </div>
  <div class="tw-w-full tw-h-fit tw-flex tw-flex-col tw-gap-4 tw-justify-center tw-items-center">
    <div *ngFor="let tab of bottomTabs" [ngClass]="tab == selectedTab ? 'tab-selected' : 'tab'" (click)="goToRoute(tab.route)">
      <img class="tab-icon" [src]="tab.icon" />
      <img class="tab-icon-selected" [src]="tab.iconSelected" />
      <p [ngClass]="isExpanded ? '' : 'tw-hidden'" class="tab-title">
        {{ tab.title | translate }}
      </p>
    </div>
  </div>
</div>
